export const weights = ["not considered", "normal", "high"];
